import { render, staticRenderFns } from "./FilePreviewModal.vue?vue&type=template&id=adb4c4f2&scoped=true&"
import script from "./FilePreviewModal.vue?vue&type=script&lang=js&"
export * from "./FilePreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./FilePreviewModal.vue?vue&type=style&index=0&id=adb4c4f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb4c4f2",
  null
  
)

export default component.exports